import { render, staticRenderFns } from "./categoryTrend.vue?vue&type=template&id=73ea7fb0&scoped=true"
import script from "./categoryTrend.vue?vue&type=script&lang=js"
export * from "./categoryTrend.vue?vue&type=script&lang=js"
import style0 from "./categoryTrend.vue?vue&type=style&index=0&id=73ea7fb0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ea7fb0",
  null
  
)

export default component.exports